import {
  PromptTestCase,
  PromptTestCaseRequest,
  PromptTestCasePreview,
  PromptTestCaseRun,
  PromptTestCaseRunRequest,
} from 'api/model';
import instance from '../axios_instance';

export const getAll = async (promptId: string): Promise<PromptTestCase[]> => {
  const response = await instance.get<PromptTestCase[]>(`/prompts/${promptId}/test-cases`);
  return response.data;
};

export const get = async (promptId: string, id: string): Promise<PromptTestCase> => {
  const response = await instance.get<PromptTestCase>(`/prompts/${promptId}/test-cases/${id}`);
  return response.data;
};

export const create = async (promptId: string, data: PromptTestCaseRequest): Promise<PromptTestCase> => {
  const response = await instance.post<PromptTestCase>(`/prompts/${promptId}/test-cases`, data);
  return response.data;
};

export const update = async (promptId: string, id: string, data: PromptTestCaseRequest): Promise<PromptTestCase> => {
  const response = await instance.put<PromptTestCase>(`/prompts/${promptId}/test-cases/${id}`, data);
  return response.data;
};

export const remove = async (promptId: string, id: string) => {
  return await instance.delete(`/prompts/${promptId}/test-cases/${id}`);
};

export const execute = async (
  promptId: string,
  id: string,
  payload: PromptTestCaseRunRequest,
  promptRevision?: number,
): Promise<PromptTestCaseRun[]> => {
  const baseUrl = `/prompts/${promptId}`;
  const url = promptRevision ? `${baseUrl}/revision/${promptRevision}` : baseUrl;
  const response = await instance.post<PromptTestCaseRun | PromptTestCaseRun[]>(
    `${url}/test-cases/${id}/runs`,
    payload,
  );
  return Array.isArray(response.data) ? response.data : [response.data];
};

export const getRuns = async (promptId: string, id: string, promptRevision?: number): Promise<PromptTestCaseRun[]> => {
  const baseUrl = `/prompts/${promptId}`;
  const url = promptRevision ? `${baseUrl}/revision/${promptRevision}` : baseUrl;
  const response = await instance.get<PromptTestCaseRun[]>(`${url}/test-cases/${id}/runs`);
  return response.data;
};

export const getPreview = async (
  promptId: string,
  testCaseData: object,
  promptRevision?: number,
): Promise<PromptTestCasePreview> => {
  const url = `/prompts/${promptId}${promptRevision ? `/revision/${promptRevision}` : ''}/preview`;
  const response = await instance.post<PromptTestCasePreview>(url, { test_case: testCaseData });
  return response.data;
};
